import React from 'react';
import Button from 'src/legacy/components/Button';

import Dropzone from 'legacyDropZone';

import _ from "lodash";
import cx from 'classnames';
import styles from './styles.module.scss';


import { Modal, Row, Col, OverlayTrigger, Popover, Image, FormGroup, InputGroup, FormControl, InputButton } from 'react-bootstrap';


import paperflitelogo from 'src/legacy/images/paperflite.svg';
import pexelslogo from 'src/legacy/images/pexels.svg';
import InfiniteScroll from 'react-infinite-scroller';
import { localizedStrings } from 'src/localization/index.jsx';
import Actions from 'src/components/actionbar';
// import VideoContainer from '../../AssetViewer/VideoViewer';

class ImageLibraryView extends React.Component {


  constructor(props) {
    super(props);

    this.state = {
      file: null,
      show: this.props.show,
      error: null,
      categoryType: { name: "All Categories", id: "" },
      mediaType: "image",
      libraryType: "default",
      pexelsQuery: "design",
      assetIconFileSizeError: false,
      showVideoThumbnailButton: false,
      groupIconFileSizeError: false,
      capturedImage: ""
    }

    this.handleFileDrop = this.handleFileDrop.bind(this);
    this.handleBrowseClicked = this.handleBrowseClicked.bind(this);
    this.handleLibraryImageClick = this.handleLibraryImageClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);
    this.handleOptionSelection = this.handleOptionSelection.bind(this);
    this.handleMediaTypeChange = this.handleMediaTypeChange.bind(this);
    this.handleGroupTypeChange = this.handleGroupTypeChange.bind(this);
    this.handlePexelsQuerySubmit = this.handlePexelsQuerySubmit.bind(this);
    this._handleChange = this._handleChange.bind(this);
    this._renderPreviewImages = this._renderPreviewImages.bind(this);
    this.handleVideoThumbnail = this.handleVideoThumbnail.bind(this);
    this.handleCaptureFrame = this.handleCaptureFrame.bind(this);
    this.handleVideoStateChange = this.handleVideoStateChange.bind(this);

    // localized contents
    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedAddBanner = localizedStrings.components.addBanner;
  }

  componentDidMount(){
    
    this.props.trackAdoptionMetricsForBannerListScreenView();
    if(this.props.type == "group"){
      this.handleGroupTypeChange("pexels");
    }
    
  }

  componentWillMount() {
    this.props.fetchLibraryImages(0, this.props.type, this.state.mediaType);
    this.props.fetchMediaLibraryCategories(this.props.type);
    if(_.get(this.props,"asset.metadata.content_type") === "video/mp4")
    {
      this.setState({
        videoURL : _.get(this.props,"asset.previewUrl") + "?=" + new Date().getTime() 
      })
    }
    
    if (this.props.libraryType === "pexels") {
      this.setState({
        libraryType: this.props.libraryType,
        mediaType: _.size(this.props.mediaType) > 0 ? this.props.mediaType : "image",
        pexelsQuery: _.size(this.props.pexelsQuery) > 0 ? this.props.pexelsQuery : "design",

      })
      
      const query = this.trimPexelsQuery(this.props.pexelsQuery)

      const body = {
        type: _.size(this.props.mediaType) > 0 ? this.props.mediaType : "image",
        mediaLibraryType: "pexels",
        query: _.size(this.props.pexelsQuery) > 0 ? query : "design",
        orientation: "landscape",
        hexcode: "",
        page: "1"

      }
      this.props.resetExternalLibrary();
      this.props.fetchExternalLibrary(body);
    }
    else if(this.props.libraryType==="default")
    {
      this.setState({
        libraryType: this.props.libraryType,
        mediaType: this.props.mediaType
      })
    }
    else if(this.props.libraryType==="videoThumbnail" || this.props.libraryType==="assetsPreview")
    {
      this.setState({
        libraryType: this.props.libraryType,
      })
    }
  }

  componentWillUnmount() {
    if(this.props.type !== "group")
      this.props.invalidateLibraryImages(this.props.type);
    }

  handleMediaTypeChange(type) {
    if (this.state.libraryType === "pexels") {
      this.setState({
        mediaType: type
      })
    
      const query = this.trimPexelsQuery(this.state.pexelsQuery)

      const body = {
        type: type,
        mediaLibraryType: "pexels",
        query: query,
        orientation: "landscape",
        hexcode: "",
        page: "1"

      }
      this.props.handleMediaSwitch(this.state.libraryType, type, this.state.pexelsQuery)
      this.props.resetExternalLibrary();
      this.props.fetchExternalLibrary(body);
    }
    else if(this.state.libraryType === "default"){
      this.setState({
        mediaType: type,
      },
        () => {
          this.props.handleMediaSwitch(this.state.libraryType, type, this.state.pexelsQuery)
          this.props.invalidateLibraryImages(this.props.type);
          if (this.state.categoryType.name === "All Categories") {
            this.props.fetchLibraryImages(0, this.props.type, this.state.mediaType);
          } else {
            this.props.fetchMediaLibraryForCategory(this.state.categoryType.id, this.props.type, this.state.mediaType);
          }
        }
      )
    }
    else{
      this.setState({
        mediaType: type,
      })
      this.props.handleMediaSwitch(this.state.libraryType, type, this.state.pexelsQuery)
          
    }
  }

  trimPexelsQuery(query){
    if(_.size(query) > 0){
      return query.replaceAll(" ", "%20")   
    }
    return "";
  }

  handleGroupTypeChange(type) {

    this.setState({
      libraryType: type,
      pexelsQuery: type === "pexels" ? "design" : ""
    }, () => {
      this.handleMediaTypeChange("image");
    })

  }

  handleBrowseClicked() {
    this.dropzone.open();
  }

  handleFileDrop(files) {
    var file = files[0];
    var error = false;
    var fileSizeInMB = (file.size / (1024 * 1024)).toFixed(1);

    if (this.props.type === "asset" && file.type.match("image.*") && fileSizeInMB > 5) {
      this.setState({
        assetIconFileSizeError: true,
        error: false,
      });
      return;
    }

    if(this.props.type === "group" && file.type.match("image.*") && fileSizeInMB > 2){
      this.setState({
        groupIconFileSizeError: true,
        error: false,
      });
      return;
    }

    if (this.props.type !== "asset" && file) {
      error = fileSizeInMB > 10;
    }

    this.setState({
      error: error,
      assetIconFileSizeError: false,
      groupIconFileSizeError: false
    })

    if (!error) {
      this.props.onChange({
        type: 'file',
        file: files[0]
      });
    }
  }

  handleLibraryImageClick(item) {
    
    var bannerType = this.state.mediaType;
    const collectionName = _.get(this.props, "folio.collection") ? _.get(this.props, "folio.collection.name") : _.get(this.props, 'folio.name');
    var cta = _.get(this.props, "source", "");
   this.props.trackAdoptionMetricsForBannerContentSelectedCollectionEvent(collectionName ,_.capitalize(bannerType), _.capitalize(cta));

    
    this.props.onChange({
      type: 'library',
      item: item
    });
  }

  _handleCancelClick() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  handleOptionSelection(field) {
    document.body.click(); //Close popover

    var newRequest = {
      ...this.state.request,
      categoryType: field.id
    };

    this.setState({
      categoryType: field,
      request: newRequest
    },
      () => {
        this.props.invalidateLibraryImages(this.props.type);
        if (this.state.categoryType.name === "All Categories") {
          this.props.fetchLibraryImages(0, this.props.type, this.state.mediaType);
        } else {
          this.props.fetchMediaLibraryForCategory(this.state.categoryType.id, this.props.type, this.state.mediaType);
        }
      }
    );
  }

  handlePexelsQuerySubmit(pexelsQuery) {

    this.props.handleMediaSwitch(this.state.libraryType, this.state.mediaType, pexelsQuery)
    const query = this.trimPexelsQuery(pexelsQuery)

    if (_.size(query) > 0) {
      const body = {
        type: this.state.mediaType,
        mediaLibraryType: "pexels",
        query: query,
        orientation: "landscape",
        hexcode: "",
        page: "1"
      }
      this.props.resetExternalLibrary();
      this.props.fetchExternalLibrary(body);
    }
  }

  _handleChange(e) {
    const query = e.target.value;
    this.setState({
      pexelsQuery: query
    });
  }

  handleAcceptedFile(){
    if(this.props.type==="asset" || this.props.type === "group")
    {
      return "image/*"
    }
    else{
      return "image/*,video/*"
    }
  }

  render() {

    var categories = [{ name: "All Categories", id: null }, ...this.props.categories];

    var options = categories.map((field, index) => {
      var selected = _.isEqual(this.state.categoryType.name, field.name);
      return (
        <div
          key={index}
          className={cx(styles.option, { [styles.active]: selected })}
          onClick={() => this.handleOptionSelection(field)}
        >
          <span className={styles.type}>{field.name}</span>
        </div>
      );
    });

    var popoverMenu = (
      <Popover id="collection_category_popover" className={styles.popover}>
        <div className={styles.categoryDropdown}>
          {options}
        </div>
      </Popover>
    );
    return (
      <div>
        <div>
          <div className={styles.toolbarGroup} direction="left">
            <div
              className={cx(styles.action)}
              width="auto"
              height="auto"
            >
              <span className={styles.actionButton}>
                <div className={styles.iconText}>
                  {this.localizedAddBanner.add_banner.description}
                  <span className={styles.iconSubtext}>{this.localizedAddBanner.add_banner.sub_text}</span>
                </div>
              </span>
            </div>

            <div className={styles.toolBar}>
            {this.state.libraryType !== "myUploads" && (
             <div>
                <Dropzone
                  className={styles.dropzone}
                  activeClassName={styles.activateDropzone}
                  ref={(node) => {
                    this.dropzone = node;
                  }}
                  accept={this.handleAcceptedFile()}
                  multiple={true}
                  disableClick={true}
                  style={{ width: "auto", height: "auto" }}
                  onDropAccepted={this.handleFileDrop}
                >
                  <span
                    className={styles.uploadFile}
                    onClick={this.handleBrowseClicked}
                  >
                    <button className={styles.uploadFileButton}>
                      <i
                        className={cx("paperflite-upload", styles.uploadIcon)}
                      />
                      <span>{this.localizedAddBanner.actions.upload_from_device}</span>

                    </button>
                  </span>
                  {this.state.error && (
                    <p className={styles.errorMessage}>
                     <i className ="fa fa-exclamation-circle" aria-hidden="true"></i>
                      <span>{localizedStrings.formatString(this.localizedAddBanner.error_messages.banner_exceed, {
                        size: '10MB'
                      })}</span>
                    </p>
                  )}
                  {this.state.assetIconFileSizeError && (
                    <p className={styles.errorMessage}>
                     <i className ="fa fa-exclamation-circle" aria-hidden="true"></i>
                      <span>{localizedStrings.formatString(this.localizedAddBanner.error_messages.banner_exceed, {
                        size: '5MB'
                      })}</span>
                    </p>
                  )}
                  {this.state.groupIconFileSizeError && (
                    <p className={styles.errorMessage}>
                      <i className ="fa fa-exclamation-circle" aria-hidden="true"></i>
                      <span>{localizedStrings.formatString(this.localizedAddBanner.error_messages.banner_exceed, {
                        size: '2MB'
                      })}</span>
                    </p>
                  )}
                </Dropzone>
              </div>
            )}
          <div className={styles.closeIcon}>
            <i
              className={cx("paperflite-close", styles.close)}
              onClick={this._handleCancelClick}
            />
          </div>
            </div>
          </div>
        </div>
        <div className={styles.groups}>
          {this.props.type !== 'group' &&
          <span
            className={cx({
              [styles.activeGroup]: this.state.libraryType === "default",
            })}
          >
            <Image src={paperflitelogo}></Image>
            <button onClick={() => this.handleGroupTypeChange("default")}>
              {this.localizedAddBanner.add_banner.options.paperflite}
            </button>
          </span>
          }

          {this.props.type !== "stream" && <span
            className={cx({
              [styles.activeGroup]: this.state.libraryType === "pexels",
            })}
          >
            <Image src={pexelslogo}></Image>
            <button onClick={() => this.handleGroupTypeChange("pexels")}>
            {this.localizedAddBanner.add_banner.options.pexels}
            </button>
          </span>}

          {this.props.type === "asset" && _.size(this.props.assetsPreview)>0 && <span
            className={cx({
              [styles.activeGroup]: this.state.libraryType === "assetsPreview",
            })}
          >
            <i className='paperflite-asset-fill'></i>
            <button onClick={() => this.handleGroupTypeChange("assetsPreview")}>
              {this.localizedAddBanner.add_banner.options.pick_from_pages}
            </button>
          </span>}  
          {_.get(this.props, "type") === "asset" && _.get(this.props,"asset.metadata.content_type").match('video.*')  && <span
            className={cx({
              [styles.activeGroup]: this.state.libraryType === "videoThumbnail",
            })}
          > 
            <i className='paperflite-video-fill'></i>
            <button onClick={() => this.handleGroupTypeChange("videoThumbnail")}>
               {this.localizedAddBanner.add_banner.options.pick_from_video}
            </button>
          </span>}

        </div>

        <div className={styles.searchbarContainer}>
          {this.state.libraryType === "pexels" &&
          <div className={styles.searchContainer}>
            <Actions.Search query={this.state.pexelsQuery} onSearch={this.handlePexelsQuerySubmit} />
            </div>
          }
        </div>
        <div className={styles.categories}>
          <div className={styles.type}>
           {this.props.type !== "asset" && <span
              className={cx({
                [styles.active]: this.state.mediaType === "image",
              })}
              onClick={() => this.handleMediaTypeChange("image")}
            >
              {this.localizedAddBanner.add_banner.options.images}
            </span>}
            {this.props.type !== "asset" && this.props.type !== "group" && <span
              className={cx({
                [styles.active]: this.state.mediaType === "video",
              })}
              onClick={() => this.handleMediaTypeChange("video")}
            >
              {this.localizedAddBanner.add_banner.options.videos}
            </span>}
          </div>

          {this.props.type === "collection" && this.state.libraryType !== "pexels" &&
            this.state.libraryType !== "myUploads" && (
              <div className={styles.categoryType}>
                <OverlayTrigger
                  trigger="click"
                  placement="bottom"
                  overlay={popoverMenu}
                  rootClose
                >
                  <div className={styles.button}>
                    <img className={styles.filterList} />
                    <span className={styles.type}>
                      {this.state.categoryType.name}
                    </span>
                    <i className={cx(styles.arrow, "fa fa-angle-down")}></i>
                  </div>
                </OverlayTrigger>
              </div>
            )}
        </div>
        {this.state.libraryType === "default" && <div className={styles.list}>
          <InfiniteScroll
            pageStart={0}
            initialLoad={false}
            hasMore={this.props.currentPage < this.props.totalPages}
            loadMore={() => {
              this.loadMoreItems();
            }}
            useWindow={false}
            threshold={250}
          >
            {this._renderLibraryImages()}
          </InfiniteScroll>
        </div>}

        {this.state.libraryType === "assetsPreview" && <div className={styles.previewPagesList}>
          <InfiniteScroll
            pageStart={0}
            initialLoad={false}
            hasMore={false}
            loadMore={() => {
             return ;
            }}
            useWindow={false}
            threshold={250}
          >
            {this._renderPreviewImages()}
          </InfiniteScroll>
        </div>}

        {this.state.libraryType === "pexels" && <div className={styles.list}>
          <InfiniteScroll
            pageStart={0}
            initialLoad={false}
            hasMore={this.props.externalLibraryCurrentPage < 30}
            loadMore={() => {
              this.loadMoreExternalItems();
            }}
            useWindow={false}
            threshold={250}
          >
            {this._renderExternalLibraryImages()}
          </InfiniteScroll>
        </div>
        }
        {/* {this.state.libraryType === "videoThumbnail" && <div className={styles.videoAssetContainer}>
          <div className={styles.videoOuterContainer}>
          <VideoContainer 
          asset={this.props.asset} 
          pictureInPictureToggle = {false} 
          onCaptureFrame = {this.handleCaptureFrame} 
          onVideoStateChange = {this.handleVideoStateChange}
          fullscreenToggle = {false}
          recordAnalytics = {false}
          />
          </div>
          {this.state.showVideoThumbnailButton && <span className={styles.videoThumbnailButton}
            onClick={this.handleVideoThumbnail}>
            <i className='paperflite-circle-right' />
            {this.localizedAddBanner.actions.make_this_as_thumbnail}
          </span>}
        
      </div>
  } */}
      </div>
    );
  }

 handleCaptureFrame(imageData){
    this.setState({
      capturedImage: imageData
    });
   
  }

  handleVideoStateChange(state) {
    if (this.state.libraryType === "videoThumbnail") {
      if (state === 'paused' && !this.state.showVideoThumbnailButton) {
        this.setState({
          showVideoThumbnailButton : true
         });
      } 

      if (state === 'playing' && this.state.showVideoThumbnailButton) {
        this.setState({
          showVideoThumbnailButton : false
         });
      }
      
    }
  }

  handleVideoThumbnail() {
    const dataUrl = this.state.capturedImage
    this.props.onChange({
      type: 'videoThumbnail',
      item: dataUrl
    });
  }

  loadMoreExternalItems() {
    let totalPages = 30;
    let currentPage = this.props.externalLibraryCurrentPage;
    let nextPage = currentPage + 1;

    if (this.props.isExternalMediaLoading) {
      return;
    }

    if (this.props.isExternalMediaLoading || nextPage > totalPages) {
      return;
    }

    const query = this.trimPexelsQuery(this.state.pexelsQuery)

    const body = {
      type: this.state.mediaType,
      mediaLibraryType: "pexels",
      query: query,
      orientation: "landscape",
      hexcode: "",
      page: nextPage
    }

    this.props.fetchExternalLibrary(body);

  }

  loadMoreItems() {
    let totalPages = this.props.totalPages;
    let currentPage = this.props.currentPage;
    let nextPage = currentPage + 1;

    if (this.props.loading) {
      return;
    }

    if (this.props.loading || nextPage > totalPages) {
      return;
    }

    if (this.state.categoryType !== "All Categories") {
      this.props.fetchLibraryImages(nextPage, this.props.type, this.state.mediaType);
    } else {
      this.props.fetchMediaLibraryForCategory(this.state.categoryType.id, this.props.type, this.state.mediaType);
    }

  }

  _renderPreviewImages() {

    if (this.props.assetsPreview) {
      var externalImages = this.props.assetsPreview.map((item, index) => {
        return (
          <div key={index} className={cx(styles.gridElement, styles[this.props.type])} onClick={this.handleLibraryImageClick.bind(this, item)}>
            <img src={item.background.full} />
          </div>
        )
      })
    }

    return (
      <div>
        {this.state.libraryType == 'assetsPreview' &&
          <div className={cx(styles.imagesContainer, styles[this.props.type])}>
            {this.props.externalMedias ? externalImages : null}
          </div>
        }
      </div>

    );
  } 

  _renderLibraryImages() {
    if(this.props.images){
      var images = this.props.images.map(item => {
        return (
          <div key={item.id} className={cx(styles.gridElement, styles[this.props.type])} onClick={this.handleLibraryImageClick.bind(this, item)}>
            <img src={item.thumbnailUrl} />
          </div>
        )
      })
    }

    return (
      <div>

        {this.state.libraryType == 'default' &&
          <div className={cx(styles.imagesContainer, styles[this.props.type])}>
            {this.props.images ? images : null}
          </div>
        }

      </div>

    );
  }

  _renderExternalLibraryImages() {

    if (this.props.externalMedias) {
      var externalImages = this.props.externalMedias.map((item, index) => {
        return (
          <div key={index} className={cx(styles.gridElement, styles[this.props.type])} onClick={this.handleLibraryImageClick.bind(this, item)}>
            <img src={item.thumbnailUrl} />
          </div>
        )
      })
    }
    if (_.size(this.props.externalMedias) === 0 && this.props.isExternalMediaLoading) {
      return (
        <p className={styles.loading}>Loading...</p>
      )
    }
    if (this.state.libraryType === "pexels" && !this.props.isExternalMediaLoading && _.size(this.props.externalMedias) === 0) {
      return (
        <p className={styles.loading}>{this.localizedAddBanner.error_messages.no_results_found}...</p>
      )
    }

    return (
      <div>

        {this.state.libraryType == 'pexels' &&
          <div className={cx(styles.imagesContainer, styles[this.props.type])}>
            {this.props.externalMedias ? externalImages : null}
          </div>
        }


      </div>

    );
  }
}

export default ImageLibraryView;